export const RENDER_MODES = {
  STATIC: "static",
  ANIMATION: "animation",
  ANIMATION_CUSTOM: "animation-custom"
};
